import { SelectMenuOptions, SelectMenuOptionsArray, SelectMenuOptionsMap } from './dynamic-form-vm';

export class DynamicFormHelper {
  public static mapSelectionMenuOptions<T>(options: T[], key: keyof T, text: Array<keyof T>, joinBy?: string): SelectMenuOptionsMap {
    const menuOption: SelectMenuOptionsMap = {};
    let selectionText: unknown[] = [];
    options.forEach((element) => {
      const el = element as Record<string, unknown>;
      let disabled: boolean;
      let disableReason: string;
      if (Object.prototype.hasOwnProperty.call(element, '_disabled')) {
        disabled = el['_disabled'] as boolean;
      }
      if (Object.prototype.hasOwnProperty.call(element, '_disableReason')) {
        disableReason = el['_disableReason'] as string;
      }

      for (const txt of text) {
        if (Object.prototype.hasOwnProperty.call(element, txt)) {
          selectionText.push(el[txt as string]);
        }
      }
      if (selectionText.length) {
        menuOption[el[key as string] as string] =
          disabled === undefined
            ? selectionText.join(joinBy ? joinBy : ' ')
            : {
              disabled,
              disableReason,
              value: selectionText.join(joinBy ? joinBy : ' '),
            };
        selectionText = [];
      }
    });

    return menuOption;
  }

  public static mapSelectionMenuOptionsPreserveOrder<T>(options: T[], key: keyof T, text: Array<keyof T>, joinBy?: string): SelectMenuOptionsArray {
    const menuOption: SelectMenuOptionsArray = [];
    let selectionText: unknown[] = [];
    options.forEach((element) => {
      const el = element as Record<string, unknown>;
      let disabled: boolean;
      let disableReason: string;
      if (Object.prototype.hasOwnProperty.call(element, '_disabled')) {
        disabled = el['_disabled'] as boolean;
      }
      if (Object.prototype.hasOwnProperty.call(element, '_disableReason')) {
        disableReason = el['_disableReason'] as string;
      }

      for (const txt of text) {
        if (Object.prototype.hasOwnProperty.call(element, txt)) {
          selectionText.push(el[txt as string]);
        }
      }
      if (selectionText.length) {
        menuOption.push({
          key: el[key as string] as string,
          value:
            disabled === undefined
              ? selectionText.join(joinBy ? joinBy : ' ')
              : {
                disabled,
                disableReason,
                value: selectionText.join(joinBy ? joinBy : ' '),
              },
        });
        selectionText = [];
      }
    });

    return menuOption;
  }

  public static convertToArray(options: SelectMenuOptions): SelectMenuOptionsArray {
    if (Array.isArray(options)) {
      return options;
    } else {
      return Object.keys(options).map((key) => ({
        key,
        value: options[key],
      }));
    }
  }

  public static convertToMap(options: SelectMenuOptions): SelectMenuOptionsMap {
    if (Array.isArray(options)) {
      const map: SelectMenuOptionsMap = {};
      options.forEach((option) => {
        map[option.key] = option.value;
      });
      return map;
    } else {
      return options;
    }
  }
}
